export default "__VITE_ASSET__r1shSHWi__"